import { RequestMethod, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { VASRestService } from '../../../core/services/api/vas-rest';
import { FileChangeQItem } from '../../../core/services/sync-up/file-item';
import { dateToString } from '../../../core/util/date-to-string';
import { FileUploadHelperInterface } from './file-upload-helper.interface';

export abstract class FileUploaderBaseHelper implements FileUploadHelperInterface {

    constructor(
        protected file: FileChangeQItem,
        protected api: VASRestService
    ) {
    }

    protected abstract getBlob(path: string): Observable<Blob>;

    abstract prepare(path: string): Promise<any>;

    abstract readChunk(path: string, index: number, size: number): Observable<Blob>;

    sendBinary(path: string, uploadUrl: string): Observable<Response> {
        return this.getBlob(path)
            .map(blob => {
                const formData = new FormData();
                formData.append('file', blob, this.file.name);
                formData.append('modified', dateToString(new Date()));
                return formData;
            })
            .map(formData => {
                return this.api.createRequest(
                    true,
                    uploadUrl,
                    RequestMethod.Post
                ).setBody(formData);
            })
            .concatMap(request => {
                // tslint:disable-next-line:no-string-literal
                request['headers'].delete('Content-Type');
                // @todo create a method on request for removing headers
                return request.execute();
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/lib/file-uploader/file-uploader-base.helper.ts